import axios from "axios";
import axiosRetry from "axios-retry";
import { applinksBaseUrl, appVersion, appVersionCode } from "@config";

const applinksAxios = axios.create({
  baseURL: applinksBaseUrl,
  timeout: 10000,
  headers: {
    "x-app-version": appVersion,
    "x-app-version-code": appVersionCode,
    "x-applinks-key": "cl_app",
    "x-applinks-secret": "2853601c-ebc9-11ec-8ea0-0242ac120002",
  },
});

axiosRetry(applinksAxios, {
  retryDelay: axiosRetry.exponentialDelay,
  retries: 3,
});

export const postApplinkEvent = (payload) =>
  applinksAxios.post("event", payload);

export const postApplinkCustomEvent = async (eventName, payload) => {
  try {
    return applinksAxios.post("/event-custom", {
      event_name: eventName,
      "event-type": "custom",
      ...payload,
    });
  } catch (e) {
    console.log(e);
  }
};

export const applinksOpen = (payload) => applinksAxios.post("open", payload);
